import { COOKIE_NAMES } from './constants';
import { readCookie, storeInCookie } from './cookies';
import { useRegistrationStore } from '../store/store';

export const timerStart = () => {
  const { setStartTime } = useRegistrationStore.getState();
  setStartTime(new Date());
};

const getTimeDifferenceInSeconds = (start: Date, end: Date): number => {
  if (!start || !end) {
    return 0;
  }
  const timeDiff: number = end.getTime() - start.getTime(); // In ms
  const seconds: number = timeDiff / 1000;

  return Math.round(seconds);
};

export const storeTimerInfo = () => {
  const { startTime } = useRegistrationStore.getState();
  if (!startTime) {
    return;
  }

  let result;
  const storedCookie = readCookie(COOKIE_NAMES.TIME_SPENT, {});
  const now = new Date();
  if (!Object.keys(storedCookie)?.length) {
    result = {
      timeSpent:         getTimeDifferenceInSeconds(startTime, now),
      numberOfOccasions: 2,
    };
  } else {
    const timeSpentSoFar = storedCookie?.userTimeSpent?.timeSpent;
    result = {
      timeSpent:         timeSpentSoFar + getTimeDifferenceInSeconds(startTime, now),
      numberOfOccasions: storedCookie?.userTimeSpent?.numberOfOccasions + 1,
    };
  }

  storeInCookie(COOKIE_NAMES.TIME_SPENT, 'userTimeSpent', JSON.stringify(result));
};

export const calculateTimeSpent = () => {
  const { startTime, setStartTime } = useRegistrationStore.getState();
  if (!startTime) {
    return null;
  }
  try {
    const storedCookie = readCookie(COOKIE_NAMES.TIME_SPENT, {});

    let result = 0;
    let numberOfOccasions = 1;
    const now = new Date();
    if (!Object.keys(storedCookie)?.length) {
      result = getTimeDifferenceInSeconds(startTime, now);
    } else {
      result =
        getTimeDifferenceInSeconds(startTime, now) +
        storedCookie?.userTimeSpent?.timeSpent;

      numberOfOccasions = storedCookie?.userTimeSpent?.numberOfOccasions;
    }

    setStartTime(null);
    if (result == null || numberOfOccasions == null) {
      console.error('result or numberOfOccasions is not valid', {
        result,
        numberOfOccasions,
      });

      return null;
    }

    return {
      timeSpent: result,
      numberOfOccasions,
    };
  } catch (error) {
    console.error('calculateTimeSpent error', error);

    return null;
  }
};
